import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import omit from 'lodash/omit';
import findIndex from 'lodash/findIndex';
import Disable from '../HOC/Disable';
import cloneDeep from 'lodash/cloneDeep';

import { utils, models } from 'gipsy-misc';
import { contact } from 'gipsy-api';

import { getFields } from './utils';

import View from './view';

var propTypes = {
  uniqueKey: PropTypes.string /* used to know when to update task */
  , mode: PropTypes.string /* create|edit|preview */
  , loading: PropTypes.bool,
  defaultTask: PropTypes.object,
  editMode: PropTypes.string,
  onEditModeChange: PropTypes.func,

  /*
   ** if an array is passed, state.task will be updated only if those fields have changed (homebase)
   ** if no array, state.task will be updated on any change (chromeext)
   **
   ** homebase case : we want to filter the fields updating the internal state "task" to avoid buggy back & forth updates between homebase and taskpanel when calling "onChange"
   ** chromeext case : we dont pass any array, we want the taskPanel to update his internal state "task" on each change, since we dont pass an "onChange" function it will only happens when we change email
   */
  fieldsToChange: PropTypes.array,
  filterFields: PropTypes.array,
  onChange: PropTypes.func,
  create: PropTypes.func,
  delete: PropTypes.func,
  closePanel: PropTypes.func,
  notifications: PropTypes.array,
  onUnmount: PropTypes.func,
  handleAPIError: PropTypes.func,
  progressPending: PropTypes.func,
  progressSuccess: PropTypes.func,
  progressError: PropTypes.func,
  approveReview: PropTypes.func,
  reopenReview: PropTypes.func
};

var defaultProps = {
  mode: 'create'
};

var TaskPanel = function (_Component) {
  _inherits(TaskPanel, _Component);

  function TaskPanel(props) {
    _classCallCheck(this, TaskPanel);

    var _this = _possibleConstructorReturn(this, (TaskPanel.__proto__ || Object.getPrototypeOf(TaskPanel)).call(this, props));

    _initialiseProps.call(_this);

    var task = props.defaultTask || models.task();
    var fields = getFields(task);
    _this.state = {
      task: task,
      fields: fields,
      /* avoid mutating notifications while the panel is active */
      notifications: cloneDeep(props.notifications),
      defaultContacts: [],
      activePrompt: false
    };

    _this.fetchContacts();
    return _this;
  }

  _createClass(TaskPanel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;

      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.task.id);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      /* we rerender only when state has changed, we dont rerender when props change */
      if (this.state.task !== nextState.task || this.state.fields !== nextState.fields || this.state.activePrompt !== nextState.activePrompt || this.state.defaultContacts !== nextState.defaultContacts || this.props.loading !== nextProps.loading || this.props.editMode !== nextProps.editMode || this.props.disabled !== nextProps.disabled /* come from HOC/Disable */
      ) {
          return true;
        }
      return false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.uniqueKey === nextProps.uniqueKey) {
        return;
      }

      var fieldsToChange = this.props.fieldsToChange;
      if (!fieldsToChange || this.props.loading && !nextProps.loading) {
        var task = Object.assign({}, nextProps.defaultTask);
        var fields = getFields(task);
        this.setState({ task: task, fields: fields });
        return;
      }

      var oldTask = pick(this.props.defaultTask, fieldsToChange);
      var nextTask = pick(nextProps.defaultTask, fieldsToChange);
      if (isEqual(oldTask, nextTask)) {
        return;
      }

      var otherFields = omit(this.state.task, fieldsToChange);
      var nextState = {
        task: _extends({}, otherFields, nextTask)
      };
      this.setState(nextState);
    }

    /* open or close field */


    /*
      paramName = task param to change
      value = new value
      method (change, add, remove) = method to follow, for an array we can add, change or remove an item (watchers, comments, tags)
    */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          task = _state.task,
          notifications = _state.notifications;


      var filteredFields = this.props.filterFields ? this.state.fields.filter(function (field) {
        return _this2.props.filterFields.indexOf(field.id) !== -1;
      }) : this.state.fields;

      return React.createElement(View, {
        mode: this.props.mode,
        onEditModeChange: this.props.onEditModeChange,
        editMode: this.props.editMode,
        task: task,
        fields: filteredFields,
        loading: this.props.loading,
        activateField: this.activateField,
        deactivateField: this.deactivateField,
        toggleField: this.toggleField,
        openField: this.openField,
        closeAllFields: this.closeAllFields,
        defaultContacts: this.state.defaultContacts,
        onChange: this.onChange,
        onChangeReview: this.onChangeReview,
        onImageUpload: this.onImageUpload,
        closePanel: this.props.closePanel,
        create: this.props.mode === 'create' ? this.create : undefined,
        togglePrompt: this.props.mode === 'edit' ? this.togglePrompt : undefined,
        activePrompt: this.props.mode === 'edit' && this.state.activePrompt,
        consentDelete: this.props.mode === 'edit' ? this.consentDelete : undefined,
        denyDelete: this.props.mode === 'edit' ? this.denyDelete : undefined,
        notifications: notifications,
        disabled: this.props.disabled,
        handleAPIError: this.props.handleAPIError,
        progressPending: this.props.progressPending,
        progressSuccess: this.props.progressSuccess,
        progressError: this.props.progressError,
        approveReview: this.props.approveReview,
        reopenReview: this.props.reopenReview
      });
    }
  }]);

  return TaskPanel;
}(Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.activateField = function (e, id) {
    return _this3.activateOrDeactivateField(e, id, true);
  };

  this.deactivateField = function (e, id) {
    return _this3.activateOrDeactivateField(e, id, false);
  };

  this.activateOrDeactivateField = function (e, id, bool) {
    /* prevent closeAllFields to be called by taskPanel onClick */
    if (e) {
      e.stopPropagation();
    }
    var index = findIndex(_this3.state.fields, ['id', id]);
    var field = _this3.state.fields[index];
    if (index === -1 || !field || field.disable) {
      return;
    }

    var fields = [].concat(_this3.state.fields);
    fields[index].isActive = bool;

    _this3.setState({
      fields: fields
    });
  };

  this.toggleField = function (e, id) {
    /* prevent closeAllFields to be called by taskPanel onClick */
    if (e) {
      e.stopPropagation();
    }
    var mode = _this3.props.mode;

    if (mode === 'preview') {
      return;
    }

    var index = findIndex(_this3.state.fields, ['id', id]);
    var field = _this3.state.fields[index];
    if (index === -1 || !field || field.disable) {
      return;
    }

    if (!field.isOpen) {
      _this3.openFieldAtIndex(index);
    } else {
      _this3.closeFieldAtIndex(index);
    }
  };

  this.openField = function (e, id) {
    if (e) {
      e.stopPropagation();
    }
    _this3.openFieldAtIndex(findIndex(_this3.state.fields, ['id', id]));
  };

  this.openFieldAtIndex = function (index) {
    var field = _this3.state.fields[index];
    if (!field || field.isOpen) {
      return;
    }
    var fields = [].concat(_this3.state.fields);

    for (var i = 0, l = fields.length; i < l; ++i) {
      fields[i].isOpen = i === index;
    }

    _this3.setState({
      fields: fields
    });
  };

  this.closeAllFields = function () {
    var fields = [].concat(_this3.state.fields);

    for (var i = 0, l = fields.length; i < l; ++i) {
      fields[i].isOpen = false;
    }

    _this3.setState({
      fields: fields,
      activePrompt: false
    });
  };

  this.closeFieldAtIndex = function (index) {
    var field = _this3.state.fields[index];
    if (!field || !field.isOpen) {
      return;
    }
    var fields = [].concat(_this3.state.fields);
    fields[index].isOpen = false;

    _this3.setState({
      fields: fields
    });
  };

  this.fetchContacts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return contact.get('');

          case 3:
            _context.t0 = _context.sent;

            if (_context.t0) {
              _context.next = 6;
              break;
            }

            _context.t0 = [];

          case 6:
            result = _context.t0;

            _this3.setState({
              defaultContacts: result
            });
            _context.next = 13;
            break;

          case 10:
            _context.prev = 10;
            _context.t1 = _context['catch'](0);

            console.error(_context.t1);

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this3, [[0, 10]]);
  }));

  this.setTask = function (task) {
    if (_this3._isMounted) {
      _this3.setState({ task: task });
    }
  };

  this.onChangeReview = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
      var paramName = _ref3.paramName,
          value = _ref3.value,
          _ref3$method = _ref3.method,
          method = _ref3$method === undefined ? 'change' : _ref3$method;
      var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var review, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(method === 'change' && value === get(_this3.state.task.review, paramName))) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return');

            case 2:
              review = utils.task.computeTaskOnChange(_this3.state.task.review, { paramName: paramName, value: value, method: method }, extraParams);

              _this3.setTask(_extends({}, _this3.state.task, { review: review }));

              if (_this3.props.onChange) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt('return');

            case 6:
              _context2.prev = 6;
              _context2.next = 9;
              return _this3.props.onChange(review, { paramName: paramName, value: value, method: method }, extraParams);

            case 9:
              response = _context2.sent;

              /* important to pass this.state.task.review because it may have changed during the request */
              review = utils.task.computeTaskAfterPatchRequestSuccess(_this3.state.task.review, { paramName: paramName, value: value, method: method }, response);
              _this3.setTask(_extends({}, _this3.state.task, { review: review }));
              return _context2.abrupt('return', response);

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2['catch'](6);

              /* important to pass this.state.task.review because it may have changed during the request */
              review = utils.task.computeTaskAfterPatchRequestError(_this3.state.task.review, { paramName: paramName, value: value, method: method }, _context2.t0);
              _this3.setTask(_extends({}, _this3.state.task, { review: review }));

            case 19:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3, [[6, 15]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.onChange = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
      var paramName = _ref5.paramName,
          value = _ref5.value,
          _ref5$method = _ref5.method,
          method = _ref5$method === undefined ? 'change' : _ref5$method;
      var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var oldValue, task, response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              /* check to avoid useless change and request */
              oldValue = get(_this3.state.task, paramName);

              if (!(value === oldValue && method === 'change')) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt('return');

            case 3:
              task = utils.task.computeTaskOnChange(_this3.state.task, { paramName: paramName, value: value, method: method }, extraParams);

              _this3.setTask(task);

              if (_this3.props.onChange) {
                _context3.next = 7;
                break;
              }

              return _context3.abrupt('return');

            case 7:
              _context3.prev = 7;
              _context3.next = 10;
              return _this3.props.onChange(task, { paramName: paramName, value: value, method: method }, extraParams);

            case 10:
              response = _context3.sent;

              /* important to pass this.state.task because it may have changed during the request */
              task = utils.task.computeTaskAfterPatchRequestSuccess(_this3.state.task, { paramName: paramName, value: value, method: method }, response);
              /* will trigger render only if task has changed with computeTaskAfterPatchRequestSucess */
              _this3.setTask(task);
              return _context3.abrupt('return', response);

            case 16:
              _context3.prev = 16;
              _context3.t0 = _context3['catch'](7);

              /* important to pass this.state.task because it may have changed during the request */
              task = utils.task.computeTaskAfterPatchRequestError(_this3.state.task, { paramName: paramName, value: value, method: method }, _context3.t0);
              /* will trigger render only if task has changed with computeTaskAfterPatchRequestSucess */
              _this3.setTask(task);

            case 20:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[7, 16]]);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  this.create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var task, result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!_this3.props.disabled) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt('return');

          case 2:
            if (!_this3.props.create) {
              _context4.next = 9;
              break;
            }

            _this3.props.disable();
            task = utils.task.computeTaskBeforeCreate(Object.assign({}, _this3.state.task));
            _context4.next = 7;
            return _this3.props.create(task);

          case 7:
            result = _context4.sent;

            /* should handle error  */
            if (_this3._isMounted) {
              _this3.props.enable();
            }

          case 9:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this3);
  }));

  this.onImageUpload = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(value) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this3.onChange({ paramName: 'uploads', value: value, method: 'add' });
              return _context5.abrupt('return', value);

            case 2:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this3);
    }));

    return function (_x5) {
      return _ref7.apply(this, arguments);
    };
  }();

  this.togglePrompt = function (e) {
    if (e) {
      e.stopPropagation();
    }
    _this3.setState({ activePrompt: !_this3.state.activePrompt });
  };

  this.consentDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var id;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!_this3.props.disabled) {
              _context6.next = 2;
              break;
            }

            return _context6.abrupt('return');

          case 2:
            if (_this3.props.delete) {
              _this3.props.disable();
              id = _this3.state.task.id;

              _this3.props.delete(id);
              _this3.setState({ activePrompt: false });
              if (_this3._isMounted) {
                _this3.props.enable();
              }
            }

          case 3:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this3);
  }));

  this.denyDelete = function () {
    _this3.setState({ activePrompt: false });
  };
};

TaskPanel.propTypes = propTypes;
TaskPanel.defaultProps = defaultProps;

export default Disable()(TaskPanel);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/index.js
// module id = 1069
// module chunks = 0